<template>
  <div class="lighten-12 card-content">
    <PieChart :data="data" />
  </div>
</template>

<script>
// Charts
import PieChart from "@/components/Charts/PieChart";

import axios from "@/plugins/axios";

export default {
  name: "Home",
  data: () => ({
    data: [],
  }),
  props:{
     type:{
      type:String,
      default: null
   }
  },

  components: {
    PieChart,
  },
  methods: {
    getSaleProductData() {
      axios
        .get(`hms/dash-board/chart/order-type?type=${this.type}`)
        .then((resp) => {
           this.data = resp.data.data;
        })
        .catch((err) => {
          console.log("Error");
        });
    },
  },
  created() {
    this.getSaleProductData();
  },
};
</script>
